import { render, staticRenderFns } from "./FormSteps.vue?vue&type=template&id=70eac8e8&scoped=true&"
import script from "./FormSteps.vue?vue&type=script&lang=js&"
export * from "./FormSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eac8e8",
  null
  
)

export default component.exports